module.exports = {"id":"192883","name":"Henrikh Mkhitaryan","rating":"84","photo":"./data/images/photos/0/192883.png","club":{"name":"Arsenal","logo":"./data/images/clubs/Arsenal.png"},"positions":["MOC","AD","MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HenrikhMkhitaryan0.json
// module id = 1727
// module chunks = 0